const EthereumCnt = {
  symbol: "SHIB",
  name: "shiba",
  meta: {
    title: "Buy shiba | Buy shiba | shiba prices and charts",
    description:
      "SHIBA is one of the most popular memes on the cryptocurrency market. Buy these funny passwords at Kevin Nick Market. Buying and selling at Sheba Nick Market is safe, fast and painless.",
    keywords: "shiba, buy shiba, sell shiba, shiba price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه شیبا اینو بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید شیبا اینو کنید. قیمت شیبا اینو در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول شیبا اینو کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در حال حاضر کیف پول‌هایی که از شیبا اینو پشتیبانی می‌کنند عبارتند از: کیف پول موبایل تراست ولت (Trust Wallet)، کیف پول تحت وب متامسک (Metamask) و کیف پول کوین نیک مارکت (Coinnik Market)",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توانم شیبا نگهداری کنم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " بله، در کوین‌نیک مارکت یک کیف پول اختصاصی و امن شیبا دارید، که می‌توانید شیبا را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا شیبا اینو ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " شیبا اینو تازه در ابتدای راه قرار دارد و طبق برنامه‌هایی که اعلام کرده، دورنمای جسورانه‌ای را پیش روی خود قرار داده است. از طرفی باتوجه به جامعه پویا و فعالی که دارد و هیجانی که اطراف دوج کوین شکل گرفته است، توانسته رشد قابل توجهی را تجربه کند. بیشتر صرافی‌های ارز دیجیتال هم که این ارز را لیست کرده‌اند و روز به روز حجم معاملات و تقاضای آن در حال افزایش است. در این مورد فقط ذکر یک نکته کافی‌ست که بسیاری از ارزهای مهم در صرافی بایننس معاملات فیوچر ندارند، بایننس معاملات فیوچر شیبا را با اهرم حداکثر ۲۵برابر فعال کرده است.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy shiba?",
      answer:
        "In coinnik Market trading platform, you can buy Sheiba Ino with Shetab member bank card and the lowest fee. The price of Shiba Ino in Quinnic Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best shiba wallet?",
      answer: "Shiba_wallet",
      id: "toggler2",
    },
    {
      question: "Can shiba be kept at Coinnik Market?",
      answer: "kept_shiba",
      id: "toggler3",
    },
    {
      question: "Is shiba Worth the Investment?",
      answer: "Shiba_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about shiba",
        subTitle: "What is an shiba?",
        content: "Shiba_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of shiba",
        content: "Shiba_history_description",
        btnTitle: "Buy and sell shiba",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell without intermediaries shiba in coinnik Market",
        subTitle: "Buy shiba Coin",
        content: "Buy_shiba_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell shiba",
        content: "Sell_shiba_description",
        btnTitle: "Buy and sell shiba",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest shiba analysis on the blog",
  informationTitle: "shiba market statistics and information",
};

export default EthereumCnt;
